import React, { useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  IconButton,
  Divider,
  Dialog
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { V_RespondentDocuments,RespondentDocuments } from "../../Reducers/dcoi";
import DownloadIcon from "@mui/icons-material/Download";
import Spinner from "../Common/Spinner/Spinner";
import "./UserPdfDialog.css";
import CheckIcon from '@mui/icons-material/Check';

const UserPdfDialog = ({ isVcoi,isOpen, onClose, handleDownloadPopup, item }) => {
  const { V_RespondentDocumentsData,RespondentDocumentsData, inProgress } = useSelector(
    (state) => state.dcoi
  );

  const dataToRender = isVcoi ? V_RespondentDocumentsData : RespondentDocumentsData;
  const dispatch = useDispatch();

  useEffect(() => {
    if (isOpen && !isVcoi) {
      dispatch(RespondentDocuments({ id: item?.ID, HFMCode: item?.HFMCode }));
    }

    if (isOpen && isVcoi) {
      dispatch(V_RespondentDocuments({ id: item?.ID, HFMCode: item?.HFMCode }));
    }
  }, [isOpen]);

  const Submit = (value) => {
    handleDownloadPopup(value);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="sm" // Ensures responsiveness
    >
      <Spinner isLoading={inProgress} />
      <Box sx={{ p: 2 }}>
        {/* Header */}
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography variant="h6" fontWeight={600}>
              Download Submission
            </Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Submitted Date Title */}
        <Typography sx={{ fontSize: "14px", fontWeight: "500", mb: 1 }}>
          Submitted Date
        </Typography>
        <Divider />

        {/* List of Submissions */}
        <Box
          sx={{
            overflowY: "auto",
            maxHeight: "350px",
            mt: 1,
            p: 1,
          }}
        >
          {Array.isArray(dataToRender) &&
          dataToRender.length > 0 ? (
            dataToRender.map((item, index) => (
              <Grid
                container
                key={index}
                alignItems="center"
                spacing={2}
                sx={{ py: 1 }}
              >
                <Grid item xs={8}>
                  <Typography sx={{display:"flex",alignItems:"center",justifyContent:"left"}}>
                    {new Date(item?.SubmissionDate).toLocaleDateString(
                      "en-US",
                      { year: "numeric", month: "long", day: "numeric" }
                    )} &nbsp; {index===0 && <span className="mappingStyle">
                      Latest <CheckIcon/>
                    </span>}
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    cursor: "pointer",
                  }}
                >
                  <DownloadIcon
                    sx={{
                      backgroundColor: " #212129",
                      padding: "8px",
                      color: "white",
                      borderRadius: "50%",
                    }}
                    onClick={() => Submit(item?.PdfBlobFileName)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              </Grid>
            ))
          ) : (
            <Typography>No data available.</Typography>
          )}
        </Box>
      </Box>
    </Dialog>
  );
};

export default UserPdfDialog;
